"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseOneOf = void 0;
const parseSchema_1 = require("./parseSchema");
const toBreadcrumb_1 = require("./toBreadcrumb");
const errors = __importStar(require("./errors"));
const parseOneOf = function ({ path, schema, direction }) {
    if (!schema.oneOf) {
        throw new errors.SchemaInvalid(`Property 'oneOf' at '${toBreadcrumb_1.toBreadcrumb(path)}' is missing.`);
    }
    if (!Array.isArray(schema.oneOf)) {
        throw new errors.SchemaInvalid(`Property 'oneOf' at '${toBreadcrumb_1.toBreadcrumb(path)}' should be an array.`);
    }
    const graphqlTypeDefinitions = [], graphqlTypeNames = [];
    schema.oneOf.forEach((subSchema, index) => {
        const result = parseSchema_1.parseSchema({ schema: subSchema, direction, path: [...path, `I${index}`] });
        graphqlTypeNames.push(result.typeName);
        graphqlTypeDefinitions.push(...result.typeDefinitions);
    });
    const graphqlTypeName = graphqlTypeNames.
        filter((name) => name.trim() !== '').
        join(' | ');
    return {
        typeName: graphqlTypeName,
        typeDefinitions: graphqlTypeDefinitions
    };
};
exports.parseOneOf = parseOneOf;
